import { 
    MOSTRAR_ALERTA, 
    OCULTAR_ALERTA,
    OBTENER_ALERTAS_VISTAS
} from 'types/context';

export default (state, action) => {
    switch(action.type) {
        case MOSTRAR_ALERTA:
            return {
                ...state,
                alerta: action.payload
            }
        case OBTENER_ALERTAS_VISTAS:
            return {
                ...state,
                alertasVistas:action.payload
            }
        case OCULTAR_ALERTA:
            return {
                alerta: null
            }
        default:
            return state;
    }
}